export default __webpack_public_path__ + "static/media/Snowflake2.ab953cea.svg";